import clsxm from '@sly/frontend/common/lib/clsxm';

export type IconSize = 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
export const IconSizes = ['xs', 's', 'm', 'l', 'xl', 'xxl'];

interface IconClasses {
  size?: IconSize;
  color?: string;
  hoverColor?: string;
  active?: boolean;
}


const getIconClasses = ({
  size = 'm',
  color,
  hoverColor,
  active,
  ...rest
}: IconClasses) => {
  const classes = ['align-baseline'];

  if (color) {
    classes.push(color);
  }

  if (hoverColor) {
    !active ? classes.push(hoverColor) : `hover:text-transparent`;
  }

  switch (size) {
    case 'xs':
      classes.push('min-w-[16px] min-h-[16px] w-[16px] h-[16px]');
      break;
    case 's':
      classes.push('min-w-[20px] min-h-[20px] w-[20px] h-[20px]');
      break;
    case 'm':
      classes.push('min-w-[24px] min-h-[24px] w-[24px] h-[24px]');
      break;
    case 'l':
      classes.push('min-w-[32px] min-h-[32px] w-[32px] h-[32px]');
      break;
    case 'xl':
      classes.push('min-w-[40px] min-h-[40px] w-[40px] h-[40px]');
      break;
    case 'xxl':
      classes.push('min-w-[48px] min-h-[48px] w-[48px] h-[48px]');
      break;
  }

  return [classes, rest];
};

export interface IconProps extends IconClasses {
  className?: string;
  class?: string;
  hoverColor?: string;
  active?: boolean;
  style?: CSSStyleSheet;
  size?: IconSize;
}

interface svgStates {
  '--active-color': string;
  '--hover-color': string;
  '--stroke-width': string;
}

const useIcon = ({
  active,
  hoverColor,
  className,
  class: _class,
  react= true,
  ...props
}: IconProps & {react?: boolean}) => {
  const svgStates: svgStates = {
    '--active-color': '',
    '--hover-color': 'transparent',
    '--stroke-width': '',
  };
 

  svgStates['--active-color'] = active ? 'currentColor' : 'transparent';
  svgStates['--stroke-width'] = active ? '2px' : '0px';

  if (hoverColor) {
    svgStates['--hover-color'] = 'transparent';
    // to-do: can't use :hover in inline style try creating utility with tailwind
    // svgStates[':hover'] = {
    //   '--hover-color': active ? 'transparent' : hoverColor,
    // };
  }

  const [iconClasses, rest] = getIconClasses({ active, ...props });

  return {
    ...rest,
    [react ? 'className': 'class']: clsxm(iconClasses, className, _class),
    style: {
      ...svgStates,
      verticalAlign: 'top',
    },
  };
};

export default useIcon;
